import axios from 'axios';
import { ErrorResponse } from 'react-router-dom';

export interface passProps {
    address: string
}

/**
 * パスワード再設定用URLを発行するAPIを呼び出す関数
 */
export async function setPassResetUrl (props: passProps){
    try{
        const response = await axios.post(process.env.REACT_APP_PATH + '/login/mail/setting', null, {
            params: {
                address: props.address
            }
        });

        return response;

    }catch(err){
        if(isApiResponse(err)){
            return err.status
        }
        return err;
    }
}

const isApiResponse = (error: unknown): error is ErrorResponse => {
    return(
        typeof error === 'object' &&
        error != null &&
        'status' in error &&
        typeof (error as ErrorResponse).status === 'number'
    );

}